/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kód slevy`
};

const da_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Rabatkode`
};

const de_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Rabattcode`
};

const en_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Discount code`
};

const es_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Código promocional`
};

const fr_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Code promo`
};

const hu_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Promóciós kód`
};

const it_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Codice sconto`
};

const nl_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kortingscode`
};

const pl_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kod rabatowy`
};

const pt_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Código promocional`
};

const sv_discount_code = /** @type {(inputs: {}) => string} */ () => {
	return `Rabattkod`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const discount_code = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_code(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_code", locale)
	if (locale === "cs") return cs_discount_code(inputs)
	if (locale === "da") return da_discount_code(inputs)
	if (locale === "de") return de_discount_code(inputs)
	if (locale === "en") return en_discount_code(inputs)
	if (locale === "es") return es_discount_code(inputs)
	if (locale === "fr") return fr_discount_code(inputs)
	if (locale === "hu") return hu_discount_code(inputs)
	if (locale === "it") return it_discount_code(inputs)
	if (locale === "nl") return nl_discount_code(inputs)
	if (locale === "pl") return pl_discount_code(inputs)
	if (locale === "pt") return pt_discount_code(inputs)
	return sv_discount_code(inputs)
};